<template>
  <fragment>
    <AppBody title="Combos" :subtitle="pageSubtitle">
      <CardModule untitle>
        <v-form
          @submit.prevent="
            getCombos({ descricao: description, status: status.value })
          "
        >
          <v-row align="center">
            <v-col cols="3">
              <BaseTextField
                label="Descrição"
                placeholder="Insira a descrição do combo"
                v-model="description"
              >
                <template v-slot:append>
                  <v-btn color="primary" icon class="mb-2" type="submit">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
              </BaseTextField>
            </v-col>
            <!-- <v-col cols="3">
              <v-btn color="primary" fab small elevation="0" type="submit">
                <v-icon>mdi-filter-outline</v-icon>
              </v-btn>
            </v-col> -->
            <v-col cols="9" class="d-flex justify-end pr-0">
              <v-chip-group
                v-model="status"
                active-class="primary--text"
                mandatory
              >
                <v-chip
                  outlined
                  v-for="(item, index) in status_items"
                  :key="index"
                  :value="item.value"
                  >{{ item.title }}</v-chip
                >
              </v-chip-group>
            </v-col>
          </v-row>
        </v-form>
        <v-row class="mt-3">
          <v-col cols="12" md="3" sm="6" xs="12" v-if="!combosLoading">
            <div class="add-combo" @click="openModal('new')">
              <v-btn color="primary" text class="rounded-pill">
                <v-icon>mdi-plus</v-icon>
                Novo Combo
              </v-btn>
            </div>
          </v-col>
          <template v-if="combosLoading">
            <v-col
              cols="12"
              md="3"
              sm="6"
              xs="12"
              v-for="loading in 12"
              :key="loading + v4()"
            >
              <v-sheet>
                <v-skeleton-loader
                  type="card"
                  class="rounded-lg"
                ></v-skeleton-loader>
              </v-sheet>
            </v-col>
          </template>
          <v-col
            v-for="(combo, index) in paginatedCombos"
            :key="index"
            cols="12"
            md="3"
            sm="6"
            xs="12"
          >
            <div
              class="combo-card rounded-lg"
              @click="openEdit('edit', combo.idcombo, combo)"
              v-if="!combosLoading"
            >
              <v-img
                :src="formatedJson(combo.imagens, 'destaque')"
                class="white--text align-end rounded-lg"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,1.5)"
                height="130px"
              >
                <v-card-title class="font-weight-bold">
                  {{ combo.descricao | cutText(13) }}
                </v-card-title>
                <v-card-subtitle v-if="combo.end_estado">
                  {{ combo.end_cidade }} - {{ combo.end_estado }}
                </v-card-subtitle>
              </v-img>
              <v-card-text>
                <v-expand-transition>
                  <v-overlay
                    class="rounded-lg"
                    v-if="combo.edit_button_loading"
                  >
                    <v-progress-circular indeterminate></v-progress-circular>
                  </v-overlay>
                </v-expand-transition>
                <v-row>
                  <v-col class="pt-1">
                    <p class="dates-card text-subtitle-3">
                      <v-icon small> mdi-calendar-month-outline </v-icon>
                      {{ combo.dthr_inicio | data_pt_br }} ~
                      {{ combo.dthr_termino | data_pt_br }}
                    </p>

                    <p class="text-body-1 font-weight-bold">
                      {{ combo.valor | moeda }}
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-btn
                color="error red lighten-2"
                fab
                v-if="!combo.edit_button_loading"
                x-small
                class="remove-img-btn rounded-pill"
                @click.stop="openConfirm(combo.idcombo)"
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
              <v-chip
                :color="getStatusColor(combo.status)"
                pill
                x-small
                class="combo-status"
              >
                {{ combo.status }}
              </v-chip>
            </div>
          </v-col>
        </v-row>
        <v-col class="mt-3 d-flex justify-center">
          <v-btn
            color="primary"
            class="rounded-pill"
            @click="seeMore"
            v-if="combos.length > showMore"
          >
            <v-icon size="40" class="floating">mdi-chevron-down</v-icon>
          </v-btn>
        </v-col>
      </CardModule>
    </AppBody>
    <comboModal />
    <confirm-modal
      v-model="deleteCombo"
      @confirm="removeComboConfirm(idcombo)"
      @cancel="deleteCombo = false"
      title="Confirmação"
      :loading="comboRemoving"
      subtitle="Tem certeza de que deseja remover o combo?"
    />
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { v4 } from "uuid";
import _ from "lodash";
export default {
  name: "Combos",
  metaInfo: {
    title: "Combos | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Combos | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      v4,
      description: "",
      deleteCombo: false,
      comboRemoving: false,
      idcombo: "",
      showMore: 11,
      items_status: [
        { title: "Ativo", value: "ATIVO" },
        { title: "Inativo", value: "INATIVO" },
        { title: "Esgotado", value: "ESGOTADO" },
      ],
      status: "TODOS",
      status_items: [
        { title: "Todos", value: "TODOS" },
        { title: "Ativos", value: "ATIVO" },
        { title: "Inativos", value: "INATIVO" },
        { title: "Esgotados", value: "ESGOTADO" },
      ],
      actions: [
        {
          name: "Novo Combo",
          action: () => this.openModal("new", ""),
          id: "NEW",
        },
      ],
      headers: [
        { text: "Combo", value: "imagens", align: "center", width: "100" },
        { text: "Descrição", value: "descricao", align: "center" },
        { text: "Status", value: "status", align: "center" },
        { text: "Data de inicio", value: "dthr_inicio", align: "center" },
        { text: "Data de fim", value: "dthr_termino", align: "center" },
        {
          text: "Ações",
          value: "actions",
          align: "center",
          width: "200",
          sortable: false,
        },
      ],
    };
  },
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    CardModule: () => import("@/components/cards/CardModule.vue"),
    comboModal: () => import("@/components/produtos/combos/comboModal.vue"),
    BaseTextField: () => import("@/components/forms/BaseTextField.vue"),
    // BaseSelect: () => import("@/components/forms/BaseSelect.vue"),
    confirmModal: () => import("@/components/global/newConfirmDialog.vue"),
  },
  methods: {
    ...mapActions([
      "toggleComboModal",
      "getCombos",
      "removeCombo",
      "cleanState",
      "getComboById",
      "setTypeCombo",
    ]),
    openModal(type) {
      this.toggleComboModal();
      this.cleanState();
      this.setTypeCombo(type);
    },

    async openEdit(type, id, item) {
      try {
        this.cleanState();

        // eslint-disable-next-line no-prototype-builtins
        if (!item.hasOwnProperty("edit_button_loading")) {
          this.$set(item, "edit_button_loading", false);
        }

        item.edit_button_loading = true;

        await this.getComboById(id);
      } catch (error) {
        console.error("Erro ao obter combo por ID:", error);
      } finally {
        item.edit_button_loading = false;
        this.setTypeCombo(type);
        this.toggleComboModal();
      }
    },
    openConfirm(id) {
      this.idcombo = id;
      this.deleteCombo = true;
    },
    async removeComboConfirm(id) {
      try {
        this.comboRemoving = true;
        await this.removeCombo(id);
      } catch (error) {
        console.error("Erro ao remover combo:", error);
        this.comboRemoving = false;
      } finally {
        this.deleteCombo = false;
        this.comboRemoving = false;
      }
    },

    formatedJson(item, tipo) {
      const img = item ? JSON.parse(item) : "";

      return tipo === "imagem1" ? img.imagem1 : img.destaque;
    },
    getStatusColor(status) {
      if (status === "ATIVO") return "success";
      return "error";
    },
    seeMore() {
      this.showMore += 12;
    },
  },
  computed: {
    ...mapGetters(["storeSequencer", "storeName", "combos", "combosLoading"]),
    pageSubtitle() {
      if (this.storeName) return "Combos - " + this.storeName;
      return "Combos";
    },
    paginatedCombos: {
      get() {
        return _.orderBy(this.filtredCombos, ["dthr_criacao"], ["desc"]).slice(
          0,
          this.showMore
        );
      },
    },
    filtredCombos() {
      return this.combos.filter(combo => {
        if (this.status === "TODOS") {
          return true;
        }
        return combo.status === this.status;
      });
    },
  },
  mounted() {
    this.getCombos();
  },
};
</script>
<style scoped lang="scss">
.combo-card {
  position: relative;
  cursor: pointer;
  max-height: 200px;
  border-radius: 50px;
  box-shadow: 11px 11px 22px #d9d9d9, 11px 11px 22px #ffffff;
  transition: all 0.2s ease-in-out;
}
.combo-card:hover {
  transform: scale(1.05);
  box-shadow: 11px 11px 12px #d9d9d9, 11px 11px 22px #ffffff;
}
.remove-img-btn {
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
}
.add-combo {
  cursor: pointer;
  height: 100%;
  min-height: 200px;
  border-radius: 20px;
  border: 2px dashed #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
}
.add-combo:hover {
  background-color: #f5f5f5;
}
.combo-status {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
}
.dates-card {
  font-size: 0.9rem;
}
.floating {
  animation: floating 1.8s ease-in-out infinite;
}
@keyframes floating {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(5px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
